module.exports = __webpack_public_path__ + "52e1c23e317135dcc552e3d22f61f0f9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-pink.png
// module id = 2271
// module chunks = 0